export default {
	'restore-path': 'Restore path',
	'delete-path': 'Delete the path',
	'select-vehicle': 'Please, select a vehicle first',
	contextmenu: {
		'add-point': 'Add point',
		'remove-point': 'Remove point'
	}
}